var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px", persistent: "" },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function(ref) {
                  var on = ref.on
                  return [
                    _c(
                      "span",
                      _vm._g({}, on),
                      [
                        _vm._t("default", [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var tooltip = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            { attrs: { icon: "" } },
                                            tooltip
                                          ),
                                          [_c("v-icon", [_vm._v("edit")])],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("global.edit")) + " ")]
                          )
                        ])
                      ],
                      2
                    )
                  ]
                }
              }
            ],
            null,
            true
          ),
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "settings.delegationRate.groupDelegationRate.formTitle"
                      )
                    )
                  )
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.formValid,
                        callback: function($$v) {
                          _vm.formValid = $$v
                        },
                        expression: "formValid"
                      }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("global.name") + "*",
                          rules: _vm.delegationRateGroup.rules().name
                        },
                        model: {
                          value: _vm.delegationRateGroup.name,
                          callback: function($$v) {
                            _vm.$set(_vm.delegationRateGroup, "name", $$v)
                          },
                          expression: "delegationRateGroup.name"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("global.description"),
                          rules: _vm.delegationRateGroup.rules().description
                        },
                        model: {
                          value: _vm.delegationRateGroup.description,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.delegationRateGroup,
                              "description",
                              $$v
                            )
                          },
                          expression: "delegationRateGroup.description"
                        }
                      }),
                      _c("delegation-rate-group-select", {
                        ref: "groupselect",
                        attrs: {
                          "except-group-id": _vm.delegationRateGroup.id,
                          label: _vm.$t(
                            "settings.delegationRate.groupDelegationRate.parentGroup"
                          ),
                          model: _vm.delegationRateGroup.parent_group_id,
                          rules: _vm.delegationRateGroup.rules().parent_group_id
                        },
                        on: {
                          "update:model": function($event) {
                            return _vm.$set(
                              _vm.delegationRateGroup,
                              "parent_group_id",
                              $event
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled:
                          !_vm.formValid || _vm.$store.getters["Ajax/loading"],
                        color: "blue darken-1",
                        text: ""
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.save($event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.save")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }